module.exports = __webpack_public_path__ + "static/media/nBklop14Il.2e39504f.jpg";